const state = {
  user: null,
  token: '',
  matchId:''
};

export default state;



// WEBPACK FOOTER //
// ./src/store/state.js